import{__module as r}from"../../../../_virtual/iterableToArray.js";var e;(e=r).exports=function(r){if("undefined"!=typeof Symbol&&null!=r[Symbol.iterator]||null!=r["@@iterator"])return Array.from(r)},e.exports.__esModule=!0,e.exports.default=e.exports;
//# sourceMappingURL=iterableToArray.js.map
